module.exports = __webpack_public_path__ + "static/media/arrow-dropdown.fd4bafe9.svg";